import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class Wso2Service {

  private readonly urlPrivacidadeESeguranca: string;

  constructor(private readonly configService: ConfigService) {
    this.urlPrivacidadeESeguranca = `${this.configService.getConfig().baseUrl}/myaccount/security`;
  }

  redirectToPrivacidadeESeguranca() {
    window.open(this.urlPrivacidadeESeguranca);
  }

}

